window.addEventListener("load", function () {
	var $swiper = document.querySelector("#Frame2 .f2-swiper");
	if (!$swiper) return;
	if (typeof Swiper === "undefined") return;

	new Swiper($swiper, {
		slidesPerView: 1,
		spaceBetween: 0,
		// Hiệu ứng chuyển slide: mờ dần (fade), crossFade để không bị chớp trắng giữa 2 banner
		effect: "fade",
		fadeEffect: { crossFade: true },
		// PC điều hướng bằng nút mũi tên; mobile bằng pagination (chấm) style Frame6
		navigation: {
			prevEl: "#Frame2 .f2-prev",
			nextEl: "#Frame2 .f2-next",
		},
		pagination: {
			el: "#Frame2 .swiper-pagination",
			clickable: true,
		},
	});
});
